var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"flex justify-center text-white p-4"},[_c('p',[_vm._v("Boardgame Shelf © 2020 - All rights reserved")])])}]

export { render, staticRenderFns }